import { gql } from "apollo-boost";
// updateShop  name router
export const UPDATE_SHOP = gql `
mutation Mutation($data: ShopInput!, $where: ShopWhereInputOne!) {
    updateShop(data: $data, where: $where) {
      id
      isLessStocks
      isBillOfferPrice
    }
  }
  `
export const UPDATE_CUSTOM_TEME = gql `
mutation UpdateCustomTheme($data: ThemeInput) {
  updateCustomTheme(data: $data) {
    id
  }
}
  `
export const CREATE_PROMOTION = gql `
mutation CreatePromotion($data: PromotionInput!) {
  createPromotion(data: $data) {
    id
  }
}
  `
export const UPDATE_PROMOTION = gql `
mutation UpdatePromotion($data: PromotionInput!, $where: PromotionWhereInput!) {
  updatePromotion(data: $data, where: $where) {
    id
  }
}
  `

